import React from 'react';
import ComparisonContent from 'components/portfolio-comparison/ComparisonContent';
import ComparisonHeader from 'components/portfolio-comparison/ComparisonHeader';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import { clsx } from 'clsx';
import { ComparisonPageType, isPageType } from 'store/ui-stores/comparison/comparisonStore';
import ProposalComparisonContent from 'components/portfolio-comparison/ProposalComparisonContent';
import ConfigComparisonContent from 'components/portfolio-comparison/ConfigComparisonContent';
import ElectionComparisonContent from 'components/portfolio-comparison/ElectionComparisonContent';
import { ComparisonUWRules } from 'components/portfolio-comparison/ComparisonUWRules';
import { createStyles } from '../../globalStyles';

const ComparePortfoliosPage = (): JSX.Element => {
  const classes = createStyles();
  const query = useQueryParams();

  const type = query.get('type') || null;
  if (!type || !isPageType(type)) {
    window.location.href = '/error-404';
  }

  const contentType = (): JSX.Element => {
    const pageType = type as ComparisonPageType;
    switch (pageType) {
      case 'proposal':
      case 'proposal-details':
      case 'ee':
        return <ProposalComparisonContent type={pageType} />;
      case 'config-portfolio':
        return <ConfigComparisonContent type={pageType} />;
      case 'available-products':
        return <ElectionComparisonContent type={pageType} />;
      default:
        return <ComparisonContent type={pageType} />;
    }
  };

  return (
    <div className={clsx(classes.pageWrapper, classes.widePageWrapper)}>
      <ComparisonHeader type={type as ComparisonPageType} />
      <ComparisonUWRules />
      {contentType()}
    </div>
  );
};

export default ComparePortfoliosPage;
